export default "__VITE_ASSET__y23FFo$E__"